export const CategoryConst ={
    BeautyCategory: {color:"#F9B9FF",image:"assets/images/beauty_category.svg"},
    BuildingCategory: {color:"#FFECE6",image:"assets/images/building_category.svg"},
    cleaningCategory: {color:"#74CDFF",image:"assets/images/cleaning_category.svg"},
    helperCategory: {color:"#C5FFC0",image:"assets/images/helper_category.svg"},
    PetCategory: {color:"#A6FFE9",image:"assets/images/pets_category.svg"},
    TechCategory: {color:"#C6A6FF",image:"assets/images/technology_category.svg"}
}